import React, { Component } from "react";
import Icon from "backpack-ui/dist/components/icon";
import { getEnv } from "shared/utils";
import Button from "../../Button";
import InputModal from "./InputModal";

class Mobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
    };
  }

  setActive = (event) => {
    event.preventDefault();

    this.setState({
      isActive: true,
    });
  };

  setInactive = () => {
    this.setState({
      isActive: false,
    });
  };

  render() {
    const {
      className,
      searchTerm,
      searchResults,
      onChange,
      onResultClick,
    } = this.props;

    const { isActive } = this.state;

    return (
      <React.Fragment>
        <Button
          element="a"
          className={className}
          href={getEnv("SEARCH_URL")}
          onClick={this.setActive}
        >
          <Icon.Search label="Open search" />
        </Button>

        <InputModal
          isOpen={isActive}
          onRequestClose={this.setInactive}
          searchTerm={searchTerm}
          searchResults={searchResults}
          onChange={onChange}
          onResultClick={onResultClick}
        />
      </React.Fragment>
    );
  }
}

export default Mobile;
